<p class="categoryLabel">Select a Category</p>


<div  *ngIf="profileCategoriesService.customerCategories && profileCategoriesService.initialized">


    <kendo-chip *ngFor="let item of profileCategoriesService.customerCategories let i = index"
                [selected]="item.selected"
                (click)="categoryClicked($event, item)"
                [look]="'outline'"
                icon=""
                selectedIcon=""
                [label]="item.description">
    </kendo-chip>
    </div>


<!--<kendo-chip-list *ngIf="profileCategoriesService.customerCategories && profileCategoriesService.initialized"
                 [selection]="'single'">
    <kendo-chip
            (click)="categoryClicked($event, item)"
            *ngFor="let item of profileCategoriesService.customerCategories let i = index"
            [label]="item.description"
            [selected]="item.selected">
    </kendo-chip>
</kendo-chip-list>-->
